import React from "react";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";

const fallbackCover = "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80";

export default function SignatureCaseRow({
  caseItem,
  isActive = false,
  onSelect,
  onTogglePublished,
  sortableDisabled = false,
}) {
  const sortable = useSortable({ id: caseItem.id, disabled: sortableDisabled });
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = sortable;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: isDragging ? "grabbing" : "grab",
  };

  const coverImage = caseItem.gallery?.[0]?.src ?? fallbackCover;
  const metaLine = caseItem.meta?.[0] ?? "";

  return (
    <article
      ref={setNodeRef}
      style={style}
      className={`signature-card${isActive ? " signature-card--active" : ""}`}
      onClick={() => onSelect?.(caseItem.id)}
      {...attributes}
      {...listeners}
    >
      <img src={coverImage} alt={caseItem.title} className="signature-card__cover" loading="lazy" />

      <div className="signature-card__body">
        <span className="signature-card__badge">{caseItem.label ?? "Signature"}</span>
        <h3 className="signature-card__title">{caseItem.title}</h3>
        {metaLine && <p className="signature-card__meta">{metaLine}</p>}
        <button
          type="button"
          className={`signature-card__status${caseItem.published === false ? " signature-card__status--draft" : ""}`}
          onClick={(event) => {
            event.stopPropagation();
            onTogglePublished?.(caseItem.id);
          }}
        >
          {caseItem.published === false ? "Taslak" : "Yayında"}
        </button>
        <div className="signature-card__actions">
          <button
            type="button"
            className="signature-card__action"
            onClick={(event) => {
              event.stopPropagation();
              onSelect?.(caseItem.id);
            }}
          >
            Aç
          </button>
          <button
            type="button"
            className="signature-card__action"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onTogglePublished?.(caseItem.id);
            }}
          >
            {caseItem.published === false ? "Yayınla" : "Taslak Yap"}
          </button>
        </div>
      </div>
    </article>
  );
}
